import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, retry, shareReplay } from 'rxjs/operators';
import { GameService } from '../../game/services/game.service';

import { DashboardWidgetModel } from '../models/dashboard-widget.model';

const API_ENDPOINT = '/api/game/';

@Injectable()
export class DashboardService {

  public forceRefresh: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private widgets: Observable<DashboardWidgetModel[]>;

  /**
   * The Constructor for this component.
   *
   * @param http HttpClient
   * @param gameService
   */
  public constructor(private http: HttpClient, private gameService: GameService) {
  }

  /**
   * Get the active widgets
   *
   * @return Observable<DashboardWidgetModel[]>
   */
  public getActiveWidgets(): Observable<DashboardWidgetModel[]> {
    const refresh = this.forceRefresh.getValue();
    if (!this.widgets || refresh) {
      this.widgets = this.loadActiveWidgets().pipe(
        shareReplay(1),
      );
    }

    return this.widgets;
  }

  /**
   * Loads all active widgets for the dashboard display.
   *
   * @return Promise regarding getting all widgets.
   */
  public loadActiveWidgets(): Observable<DashboardWidgetModel[]> {
    return this.http.get(API_ENDPOINT + 'get/widgets')
    .pipe(
      retry(3),
      map((response: { items: { widgets: DashboardWidgetModel[] } }) => {
        return response.items.widgets;
      }),
    );
  }

  /**
   * Mark widget as being seen.
   *
   * @param moduleName
   */
  public setWidgetSeen(moduleName: string): Observable<any> {
    return this.http.post(API_ENDPOINT + 'set/widget/seen', { module: moduleName })
    .pipe(
      retry(3),
    );
  }

  /**
   * Clear all widgets so cache needs to be reloaded.
   *
   * @return void
   */
  public clearWidgets(): void {
    this.widgets = null;
  }
}
